// @ts-nocheck
import { createAction } from '@reduxjs/toolkit';

export const triggerAddAccessLevel = createAction(
	'rowAccess/triggerCreate',
	({ selectedEntities, accessLevel, userId }) => ({
		payload: {
			selectedEntities,
			accessLevel,
			userId,
		},
	})
);

export const triggerAddUserRole = createAction('users/addRole', ({ userId, roles, isForced }) => ({
	payload: {
		userId,
		roles,
		isForced,
	},
}));

export const triggeRemovebulkAccess = createAction('users/removebulkAccess', ({ tableId, ids }) => ({
	payload: {
		tableId,
		ids,
	},
}));

export const triggeRemoveRowAccess = createAction('rowAccess/removeAccess', ({ userId, selectedEntities }) => ({
	payload: {
		userId,
		selectedEntities,
	},
}));
